<template>
  <div>
    <table class="table table-sm">
      <thead></thead>
      <tbody>
        <tr>
          <td>VALOR DA VENDA</td>
          <td>
            <strong>{{ formatReal(String(sale.value)) }}</strong>
          </td>
        </tr>
        <tr>
          <td>
            {{ sale.type == "MEDICINE" ? "MEDICAMENTO" : "PRODUTO" }} DA EMPRESA
          </td>
          <td>
            <strong>{{ sale.rest_home_medicine_product_name }}</strong>
          </td>
        </tr>
        <tr>
          <td>
            {{ sale.type == "MEDICINE" ? "MEDICAMENTO" : "PRODUTO" }} DO
            RESIDENTE
          </td>
          <td>
            <strong>{{ sale.item_name }}</strong>
          </td>
        </tr>
        <tr>
          <td>RESIDENTE</td>
          <td>
            <strong>{{ sale.resident_name }}</strong>
          </td>
        </tr>
        <tr>
          <td>RESPONSÁVEL</td>
          <td>
            <strong>{{
              professionalClassCouncilValue({
                id: sale.user_professional_class_council_id,
                name: sale.user_name,
                profile: sale.user_profile_name,
                office: sale.user_office,
                cpf: sale.user_cpf,
                value: sale.user_professional_class_council_value,
              })
            }}</strong>
          </td>
        </tr>
        <tr>
          <td>GRUPO DA EMPRESA</td>
          <td>
            <strong>{{ sale.rest_home_stock_group_name }}</strong>
          </td>
        </tr>
        <tr>
          <td>GRUPO DO RESIDENTE</td>
          <td>
            <strong>{{ sale.stock_group_name }}</strong>
          </td>
        </tr>
        <tr>
          <td>LOTE</td>
          <td>
            <strong>{{ sale.lot }}</strong>
          </td>
        </tr>
        <tr>
          <td>{{ sale.stock_item_unit_of_measurement_abbreviation }}</td>
          <td>
            <strong>
              {{ sale.amount }}
              {{ sale.stock_item_unit_of_measurement_abbreviation }}
            </strong>
          </td>
        </tr>
        <tr>
          <td>DATA DE VENCIMENTO</td>
          <td>
            <strong>{{
              sale.due_date
                ? moment(sale.due_date).format("MM/YYYY")
                : "NÃO INFORMADO"
            }}</strong>
          </td>
        </tr>
        <tr v-if="sale.description">
          <td>DESCRIÇÃO</td>
          <td>
            <strong>{{ sale.description }}</strong>
          </td>
        </tr>
        <tr>
          <td>DATA DA VENDA</td>
          <td>
            <strong>{{
              moment(sale.created_at).format("DD/MM/YYYY HH:mm:ss")
            }}</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment";

import {
  professionalClassCouncilValue,
  formatReal,
} from "../../../../../lib/format";

export default {
  name: "Details",

  props: {
    sale: { type: Object },
  },

  methods: {
    moment,
    professionalClassCouncilValue,
    formatReal,
  },
};
</script>
